import React, { useState, useEffect, Image } from 'react';
import { db } from '../../firebase';
import { collection, query, getDocs } from '@firebase/firestore';
import { useNavigate } from "react-router-dom";
import { PRODUCT_IMAGES_URL_PREFIX } from '../../constants/constants';
import BackgroundImage from '../../images/yale_golf_course.jpg'
import { useWindowSize } from '../../utils';

function ShopSection() {
  
  const navigate = useNavigate();

  const [windowWidth, windowHeight] = useWindowSize();

  const [itemList, setItemList] = useState([]);

  const fetchData = async () => {
    const localItemList = []
    const querySnapshot = await getDocs(collection(db, "products"));
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      const docData = doc.data()
      const imgUrls = []
      for (var i = 0; i < docData.images.length; i++) {
        const imgUrl = PRODUCT_IMAGES_URL_PREFIX + docData.images[i]
        imgUrls.push(imgUrl)
      }
      localItemList.push({
        name: docData.name,
        itemId: docData.itemId,
        images: imgUrls,
        color: docData.color,
        price: docData.price,
        quantityRemaining: docData.quantityRemaining,
        active: docData.active
      })
    });
    setItemList(localItemList)
  }

  useEffect(() => {
    fetchData()
  }, []);

  const openDetailPage = (itemId) => {
    console.log(itemId)
    navigate("/shop/detail/" + itemId)
  }

  // Since we are using flexbox to display the items, and we want that
  // flexbox centered in the page but left align for incomplete rows,
  // we need to have justifyContent: center and then add empty items
  // to have the appearance of left align.  This function calculates
  // how many extra empty items we need.
  const makeCorrectionForEmptySpots = (totalItems) => {

    let itemsPerRow = 3
    if (windowWidth >= 900) {
      itemsPerRow = 3
    }
    else if (windowWidth < 900 && windowWidth >= 600) {
      itemsPerRow = 2
    }
    else if (windowWidth < 600) {
      itemsPerRow = 1
    }

    return totalItems % itemsPerRow
  }

  const ItemImage = ({image1Url, image2Url}) => {
    const [hover, setHover] = useState(false)

    const mouseOver = (event) => {
        setHover(true)
    }

    const mouseOut = (event) => {
        setHover(false)
    }

    return (
        <div onMouseEnter={mouseOver} onMouseLeave={mouseOut} className="flex gap-3">
            <img src={hover ? `/${image2Url}` : `/${image1Url}`} alt="img" style={{ width: "200px", borderRadius: "4px", boxShadow: "0 4px 20px rgba(13,24,16,0.3)", transition: "transform 0.3s ease, box-shadow 0.3s ease", transform: hover ? "scale(1.03)" : "scale(1)" }} />
        </div>
    );

  }

  const createShopList = () => {
    const localList = []
    for (var i = 0; i < itemList.length; i++) {
      const image1Url = itemList[i]['images'][0]
      const image2Url = itemList[i]['images'][1]
      const itemId = itemList[i]['itemId']
      const itemName = itemList[i]['name']
      const isActive = itemList[i]['active']
      const itemPrice = "$" + (itemList[i]['price'] / 100).toString()
      const qtyRemaining = itemList[i]['quantityRemaining']
      const outOfStock = qtyRemaining === 0
      if (isActive || outOfStock) {
        localList.push(
          <div
            key={i}
            onClick={outOfStock ? undefined : () => openDetailPage(itemId)}
            style={{ marginBottom: "70px", cursor: outOfStock ? "default" : "pointer", textAlign: "center", marginLeft: "35px", marginRight: "35px", opacity: outOfStock ? 0.65 : 1 }}
          >
              <div style={{ position: "relative", display: "inline-block" }}>
                <ItemImage key={i} image1Url={image1Url} image2Url={image2Url} />
                {outOfStock && (
                  <div style={{ position: "absolute", top: "8px", right: "8px", background: "rgba(13,24,16,0.85)", border: "1px solid rgba(184,137,42,0.5)", borderRadius: "3px", padding: "3px 8px", fontFamily: "Raleway, sans-serif", fontSize: "10px", fontWeight: 700, letterSpacing: "1.5px", textTransform: "uppercase", color: "#C4A875" }}>
                    Out of Stock
                  </div>
                )}
              </div>
              <p style={{ paddingTop: "12px", color: "#F5EFE3", fontFamily: "Raleway, sans-serif", fontWeight: "600", fontSize: "14px", letterSpacing: "0.5px" }}>{itemName}</p>
              <p style={{ paddingTop: "6px", color: outOfStock ? "#8A8A82" : "#B8892A", fontFamily: "Raleway, sans-serif", fontWeight: "500", fontSize: "14px", letterSpacing: "1px" }}>{outOfStock ? "Out of Stock" : itemPrice}</p>
          </div>
        )
      }
    }
    // setOver(localOver)
    const numOfEmtpySpotsToAdd = makeCorrectionForEmptySpots(itemList.length)
    for (var i = 0; i < numOfEmtpySpotsToAdd; i++) {
      localList.push(
        <div key={i} style={{ marginBottom: "70px", marginLeft: "35px", marginRight: "35px" }}>
            <div style={{ width: "200px" }} />
            <p style={{ paddingTop: "10px", color: "white" }}></p>
            <p style={{ paddingTop: "10px", color: "white" }}></p>
        </div>
      )
    }
    return (
      <div style={{ marginTop: "20px", display: "flex", width: "calc(100%)", flexDirection: "row", flexWrap: "wrap", justifyContent: "center" }}>
        {localList}
      </div>
    )
  }


  // TODO: for mobile, change the filter styling.

  return (
    <>
      <div style={{ backgroundImage: `linear-gradient( rgba(13, 24, 16, 0.55), rgba(13, 24, 16, 0.85) ), url(${BackgroundImage})`, backgroundSize: "cover", backgroundPosition: "center", backgroundAttachment: "fixed" }}>
        <div style={{ paddingTop: "125px", minHeight: "calc(100vh - 200px)", display: "flex", justifyContent: "center" }}>
            <div style={{ width: "90%", maxWidth: "900px" }}>
            <div style={{ marginBottom: "12px" }}>
              <h3 style={{ color: "#C4A875", fontFamily: "Raleway, sans-serif", fontWeight: "500", fontSize: "13px", letterSpacing: "1px", textTransform: "uppercase" }}><a href='/' style={{ color: "#C4A875", textDecoration: "none" }} >Home</a> <span style={{ color: "#B8892A", margin: "0 6px" }}>&#47;</span> <a href='/shop' style={{ color: "#F5EFE3", textDecoration: "none" }} >Shop</a></h3>
            </div>
            {createShopList()}
          </div>
        </div>
      </div>
    </>
  );
}

export default ShopSection;